module.exports = __webpack_public_path__ + "static/media/hya-diamond.a76793d0.png";